import { useState } from 'react';
import type { ViewState } from 'react-map-gl';

export const useMapState = () => {
  const [viewState, setViewState] = useState<ViewState>({
    longitude: 37.6,
    latitude: 4.5,
    zoom: 4,
    pitch: 10,
    bearing: 0,
    padding: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
  });

  const [isStyleLoaded, setIsStyleLoaded] = useState(false);

  return {
    viewState,
    setViewState,
    isStyleLoaded,
    setIsStyleLoaded,
  };
};
